
export interface TramiteEmvs {

    id:                 number;
    usuario_id?:        UsuarioID;
    autorizaciones?:    Autorizacione[];
    puestos?:           Puesto;
    unidades?:          Autorizacione[];
    procedimiento_id?:  ProcedimientoID;
    fechaAlta?:         number[];
    fechaBaja?:         string;
    fechaModificacion?: string;
    pdfCliente?:        string;
    pdfServidor?:       string;
    estado?:            boolean;
    estadoFirma?:       EstadoTramite;
    lastVisitedTab?:    string;
    firmarClave?:       boolean;
    pdfFirmado?:        string;
    custom?:            boolean;
    jsonTramite?:       string;
    telefono2?:         string;
    telefono3?:         string;
    numeroRegistroEmvs?:number;
    sobreescribeTramitePrevio?:Boolean;


}

export enum EstadoTramite {
    FIRMADO_CON_REGISTRO = "FIRMADO_CON_REGISTRO",
    FIRMADO_SIN_REGISTRO = "FIRMADO_SIN_REGISTRO",
    PENDIENTE_DE_FIRMA = "PENDIENTE_DE_FIRMA",
    NO_FINALIZADO = "NO_FINALIZADO",
    DADO_BAJA_AUTOMATICA = "DADO_BAJA_AUTOMATICA",
    DADO_BAJA_FIN_PROCEDIMIENTO = "DADO_BAJA_FIN_PROCEDIMIENTO",
    DADO_BAJA_USUARIO = "DADO_BAJA_USUARIO",
    PROCESANDO = "PROCESANDO",
    PENDIENTE_DE_FIRMA_AUTORIZADOS = "PENDIENTE_DE_FIRMA_AUTORIZADOS",
    ANULADO_POR_FIRMANTE = "ANULADO_POR_FIRMANTE",
    FIRMADO_BAJA_USUARIO = "FIRMADO_BAJA_USUARIO",
    RECHAZADA = "RECHAZADA",
    RECHAZADO_UNIDAD_FAMILIAR ="RECHAZADA"
};
export enum EstadoTramiteReturn {
    FIRMADO_CON_REGISTRO = "COMPLETADO",
    FIRMADO_SIN_REGISTRO = "PENDIENTE DE REGISTRO",
    PENDIENTE_DE_FIRMA = "PENDIENTE DE FIRMA",
    NO_FINALIZADO = "NO FINALIZADO",
    DADO_BAJA_AUTOMATICA = "BAJA POR INACTIVIDAD",
    DADO_BAJA_FIN_PROCEDIMIENTO = "BAJA POR CIERRE DE PROCEDIMIENTO",
    DADO_BAJA_USUARIO = "BAJA POR USUARIO",
    PROCESANDO = "PROCESANDO TRAMITE",
    PENDIENTE_DE_FIRMA_AUTORIZADOS = "PENDIENTE DE FIRMA AUTORIZADOS",
    ANULADO_POR_FIRMANTE = "ANULADO POR FIRMANTE",
    FIRMADO_BAJA_USUARIO = "FIRMADO BAJA USUARIO",
    RECHAZADA ="RECHAZADA",
    RECHAZADO_UNIDAD_FAMILIAR ="RECHAZADA"
};

export function esTramiteDadoDeBaja(estadoFirma?: string): boolean {
    return estadoFirma === EstadoTramite.DADO_BAJA_AUTOMATICA
        || estadoFirma === EstadoTramite.DADO_BAJA_FIN_PROCEDIMIENTO
        || estadoFirma === EstadoTramite.DADO_BAJA_USUARIO
        || estadoFirma === EstadoTramite.FIRMADO_BAJA_USUARIO;
}
export enum EstadoTramiteQuery {
    "COMPLETADO" = "FIRMADO_CON_REGISTRO",
    "PENDIENTE DE REGISTRO" = "FIRMADO_SIN_REGISTRO",
    "PENDIENTE DE FIRMA" = "PENDIENTE_DE_FIRMA",
    "NO FINALIZADO" = "NO_FINALIZADO",
    "BAJA POR INACTIVIDAD" = "DADO_BAJA_AUTOMATICA",
    "BAJA POR CIERRE DE PROCEDIMIENTO" = "DADO_BAJA_FIN_PROCEDIMIENTO",
    "BAJA POR USUARIO" = "DADO_BAJA_USUARIO",
    "PENDIENTE DE FIRMA AUTORIZADOS" = "PENDIENTE_DE_FIRMA_AUTORIZADOS",
    "RECHAZADA" = "RECHAZADA",
    "RECHAZADO UNIDAD FAMILIAR" ="RECHAZADA"
};
export interface Autorizacione {
    id:                  number;
    documento:           string;
    apellidos_nombre:    string;
    fecha_nacimiento:    string;
    estado_civil:        Tipopersona;
    parentesco:          string;
    tramite:             string;
    grado_discapacidad?: Tipopersona;
    grado_dependencia?:  Tipopersona;
}

export interface Tipopersona {
    id:     number;
    nombre: string;
}

export interface ProcedimientoID {
    id:                              number;
    nombre?:                          string;
    visible?:                         boolean;
    link_ayuda?:                      string;
    link_ordenanza?:                  string;
    fechaCierre?:                     string;
    fechaApertura?:                   string;
    tipoProcedimientoAdministrativo?: TipoProcedimientoAdministrativo;
    departamento?:                    Departamento;
    fechaAlta?:                       string;
    fechaModificacion?:               string;
    fechaBaja?:                       string;
    link_path?:                       string;
    custom?:                          boolean;

}

export interface Departamento {
    id:            number;
    nombre:        string;
    departamentos: string[];
}

export interface TipoProcedimientoAdministrativo {
    id:    number;
    valor: string;
}

export interface Puesto {
    id:           number;
    idDocumento1: number;
    idDocumento2: number;
    solicitudes:  Solicitude[];
    tramite:      string;
}

export interface Solicitude {
    id:           number;
    preferencia:  string;
    convocatoria: string;
    denominacion: Denominacion;
}

export interface Denominacion {
    id: number;
    nombre: string;
    puesto: string;
}
export interface UsuarioID {
    id:                    number;
    nombre:                string;
    email:                 string;
    apellido1:             string;
    apellido2:             string;
    rol:                   Tipopersona[];
    departamento:          Departamento;
    fechaNacimiento:       string;
    titulacion:            string;
    authorities:           Authority[];
    twoFactorSecret:       string;
    twoFactorEnabled:      boolean;
    tipo_documento:        TipoDocumento;
    numero_documento:      string;
    direcciones:           Direccione[];
    tipopersona:           Tipopersona;
    notificaciones:        string;
    telefono:              string;
    genero:                string;
    clave:                 boolean;
    enabled:               boolean;
    username:              string;
    accountNonExpired:     boolean;
    credentialsNonExpired: boolean;
    third:                 boolean;
    authentication:        Authentication;
    accountNonLocked:      boolean;
}

export interface Authentication {
    authorities:   Authority[];
    details:       Credentials;
    authenticated: boolean;
    principal:     Credentials;
    credentials:   Credentials;
    name:          string;
}

export interface Authority {
    authority: string;
}

export interface Credentials {
}

export interface Direccione {
    id:           number;
    type_of_road: TypeOfRoad;
    name_road:    string;
    number_road:  string;
    block:        string;
    stairs:       string;
    floor:        string;
    door:         string;
    postal_code:  string;
    country:      Country;
    ccaa:         Ccaa;
    province:     Province;
    municipality: string;
    isActive:     boolean;
    fechaAlta:    string;
}

export interface Ccaa {
    id:     string;
    nombre: string;
    pais:   Country;
}

export interface Country {
    id:     string;
    nombre: string;
}

export interface Province {
    id:     string;
    ccaa:   Ccaa;
    nombre: string;
}

export interface TypeOfRoad {
    id:                 number;
    tipovia:            string;
    tipovianormalizado: string;
    descripcion:        string;
    visible:            boolean;
}

export interface TipoDocumento {
    id:     number;
    codigo: string;
    nombre: string;
}
